// extracted by mini-css-extract-plugin
export default {"input":"ShopifyAuthenticate_input__t0woh"};